import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const MissingDataSensorIcon = ({
  Icon,
  width = 130,
  height = 40,
  borderColor,
  backgroundColor,
  circleColor,
  borderStyle = 'dashed',
  text = 'Missing Info',
  className,
  ...rest
}: {
  Icon: React.ReactNode;
  width?: number;
  height?: number;
  borderColor?: string;
  backgroundColor?: string;
  circleColor?: string;
  borderStyle?: string;
  text?: string;
  className?: string;
  [key: string]: unknown;
}) => {
  const { token } = useToken();
  const currentBorderColor = borderColor ?? token.colorBorder;
  const currentBackgroundColor = backgroundColor ?? token.colorBgBase;
  const currentCircleColor = circleColor ?? token.colorPrimary;

  const rectWidth = 120;
  const viewBoxWidth = 130;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${viewBoxWidth} 40`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <path d="M4 26H2C0.895431 26 0 25.1046 0 24L0 16C0 14.8954 0.895431 14 2 14H4L4 26Z" fill={token.colorBorder} />
      <rect x="4.5" y="1.5" width={rectWidth} height="37" rx="18.5" fill={currentBackgroundColor} />
      <rect x="4.5" y="1.5" width={rectWidth} height="37" rx="18.5" stroke={currentBorderColor} strokeWidth="3" strokeDasharray={borderStyle === 'dashed' ? '5,5' : undefined} />
      <path d={`M${4.5 + rectWidth} 14H${6.5 + rectWidth}C${7.6 + rectWidth} 14 ${8.5 + rectWidth} 14.8954 ${8.5 + rectWidth} 16V24C${8.5 + rectWidth} 25.1046 ${7.6 + rectWidth} 26 ${6.5 + rectWidth} 26H${4.5 + rectWidth}V14Z`} fill={token.colorBorder} />
      <circle cx="23" cy="20" r="12" fill={currentCircleColor} />
      {Icon}
      <text
        x="40"
        y="24"
        fill={currentBorderColor}
        fontSize={token.fontSize}
        fontFamily={token.fontFamily}
        fontWeight="400"
        textAnchor="start"
      >
        {text}
      </text>
    </svg>
  );
};

export default MissingDataSensorIcon;
